
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { IFormItem, IOption, TDateType } from './PublicQuery'

const VALUE_CACHE_MAP: any = {}

@Component({
  components: {},
})
export default class PublicQuery extends Vue {
  @Prop({ type: Array }) items!: IFormItem[]
  @Prop({ type: Object }) value!: any
  /** 开启下载按钮 */
  @Prop({ type: [Boolean, Function], default: false }) showDownload!: Boolean | Function
  @Prop({ type: [Boolean, Function], default: true }) showSearch!: Boolean | Function
  @Prop({ type: String }) labelWidth?: string
  /** 是否触发所有参数变化执行change */
  @Prop({ type: Boolean, default: true }) isWatcher?: boolean
  /** 是否初始化完成 */
  private isInited: boolean = false
  private get _queryParams() {
    return this.value
  }
  private set _queryParams(val) {
    this.$emit('input', val)
  }
  /** 是否显示下载 */
  private get _showDownload() {
    return typeof this.showDownload === 'function' ? this.showDownload() : this.showDownload
  }
  /** 是否显示搜索 */
  private get _showSearch() {
    return typeof this.showSearch === 'function' ? this.showSearch() : this.showSearch
  }

  private get itemsSync() {
    const items = this._clone(this.items)
    const promiseMap = new Map()
    items.forEach((formItem: IFormItem) => {
      if (formItem.request) {
        if (Object.prototype.toString.call(formItem.request) === '[object Promise]') {
          const fid = this._getFid(8)
          promiseMap.set(fid, formItem.request)
          ;(formItem._fid as string) = fid
        } else {
          console.error(`${formItem.label}参数"request"仅支持Promise`)
        }
      }
      const defaultValue = this._queryParams[formItem.key]
      const cacheValue = formItem.cacheKey && VALUE_CACHE_MAP[formItem.cacheKey!]
      if (!defaultValue && cacheValue !== undefined) {
        this._queryParams[formItem.key] = cacheValue
      }
    })
    /** 确保异步任务全部完成后执行 initChange */
    Promise.all([...promiseMap.values()]).then(payload => {
      Array.from(promiseMap.keys()).map((fid: string, index: number) => {
        items.forEach((formItem: IFormItem) => {
          if (formItem._fid === fid) {
            const options = (formItem.requested
              ? formItem.requested(payload[index], formItem)
              : payload[index]) as IOption[]
            if (formItem.type === 'select' || formItem.type === 'dropdown') {
              this.$set(formItem, 'options', options)
              const defaultValue = this._queryParams[formItem.key]
              if (defaultValue && !options.some(o => o.value === defaultValue)) {
                this._queryParams[formItem.key] = undefined
              }
              if (!defaultValue && options.length > 0) {
                const cacheValue = VALUE_CACHE_MAP[formItem.cacheKey!]
                if (cacheValue && options.some(o => o.value === cacheValue)) {
                  this._queryParams[formItem.key] = cacheValue
                } else if (formItem.autoSelect) {
                  this._queryParams[formItem.key] = options[0].value || ''
                  if (formItem.cacheKey) VALUE_CACHE_MAP[formItem.cacheKey] = this._queryParams[formItem.key]
                }
              }
            } else if (formItem.type === 'input') {
              const defaultValue = this._queryParams[formItem.key]
              const cacheValue = formItem.cacheKey && VALUE_CACHE_MAP[formItem.cacheKey!]
              if (!defaultValue && cacheValue !== undefined) {
                this._queryParams[formItem.key] = cacheValue
              }
            }
          }
        })
      })
      /** 异步回调 可做为queryForm初始化完成事件 */
      if (!this.isInited) {
        this.isInited = true
        this.$emit('initChange', items)
      }
    })
    return items
  }

  private handleChange(key: string, value: any) {
    if (this.isWatcher) {
      this.cacheSelection(key, value)
      this.$emit('change')
    }
  }

  private handleCommand(key: string, command: any) {
    this._queryParams[key] = command
    this.cacheSelection(key, command)
    this.$emit('change')
  }

  private onQuery() {
    this.$emit('change', { isUseCache: false })
  }

  private cacheSelection(key: string, value: any) {
    const formItem = this.items.find(item => item.key === key)
    if (formItem && formItem.cacheKey) {
      VALUE_CACHE_MAP[formItem.cacheKey] = value
    }
  }
  private _getDateFormItemAutoConfig(item: IFormItem) {
    const dateType = item.dateType || 'date'
    let dateConfig: any = {
      datetime: {
        width: '200px',
        valueFormat: 'yyyy-MM-dd HH:mm:ss',
      },
      datetimerange: {
        width: '400px',
        valueFormat: 'yyyy-MM-dd HH:mm:ss',
      },
      date: {
        width: '180px',
        valueFormat: 'yyyy-MM-dd',
      },
      daterange: {
        width: '260px',
        valueFormat: 'yyyy-MM-dd',
      },
      monthrange: {
        width: '260px',
        valueFormat: 'yyyy-MM-dd',
      },
    }
    return dateConfig[dateType as TDateType] || {}
  }

  private _getFid(length: any) {
    return Number(
      Math.random()
        .toString()
        .substr(3, length) + Date.now(),
    ).toString(36)
  }

  private _clone(target: any) {
    let result: any
    const toString = Object.prototype.toString
    if (toString.call(target) === '[object Array]') {
      result = []
      for (let i = 0; i < target.length; i++) {
        this.$set(result, i, target[i])
      }
    } else if (toString.call(target) === '[object Object]') {
      result = {}
      for (let key in target) {
        this.$set(result, key, target[key])
      }
    } else if (toString.call(target) === '[object RegExp]') {
      result = target
    }
    return result
  }
}
